export const MODEL_LOADING = 'MODEL_LOADING';
export const MODEL_FULFILLED = 'MODEL_FULFILLED';
export const MODELS_FULFILLED = 'MODELS_FULFILLED';
